import { useDispatch } from 'react-redux';
import { EnableSpinner, DisableSpinner } from '../redux/actions/screenActions';

export default function useSpinner() {
  const dispatch = useDispatch();

  const enableSpinner = () => dispatch(EnableSpinner());
  const disableSpinner = () => dispatch(DisableSpinner());

  return [enableSpinner, disableSpinner];
}
